import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fechaEspanol',
  standalone: true
})
export class FechaEspanolPipe implements PipeTransform {

  transform(value: Date | string | number | undefined | null, tipo: 'normal' | 'relativa' | 'extendida' = 'normal'): string {
    if (!value) {
      return 'Fecha no disponible';
    }

    const fecha = new Date(value);
    const ahora = new Date();

    if (tipo === 'relativa') {
      const diferencia = ahora.getTime() - fecha.getTime();
      const segundos = Math.floor(diferencia / 1000);
      const minutos = Math.floor(segundos / 60);
      const horas = Math.floor(minutos / 60);
      const dias = Math.floor(horas / 24);

      if (dias > 0) {
        return `hace ${dias} ${dias === 1 ? 'día' : 'días'}`;
      } else if (horas > 0) {
        return `hace ${horas} ${horas === 1 ? 'hora' : 'horas'}`;
      } else if (minutos > 0) {
        return `hace ${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}`;
      } else {
        return 'hace unos segundos';
      }
    } else if (tipo === 'extendida') {

      return this.capitalizeFirstLetter(formatDate(fecha, "EEEE, d 'de' MMMM, yyyy", 'es-CO'));
    } else {

      return formatDate(fecha, 'dd/MM/yyyy, hh:mm a', 'es-CO');
    
    }
  }

  private capitalizeFirstLetter(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
